import { observer } from 'mobx-react-lite'
import { Dropdown, Icon, Typography } from 'shared/ui'
import { type IResponseInboxGroupTeam } from 'entities/Inbox/api/types'
import styles from './styles.module.scss'

export type IMembersCellProps = {
  members: IResponseInboxGroupTeam[]
  visibleItemsCount?: number
}

export const MembersCell = observer(({ members, visibleItemsCount = 1 }: IMembersCellProps) => {
  const visibleMembers = members.slice(0, visibleItemsCount)
  const hiddenMembers = members.slice(visibleItemsCount)

  return (
    <div className={styles.membersCell}>
      {visibleMembers.map((member) => (
        <div key={member.id} className={styles.memberItem}>
          <Icon icon={'inboxOpen'} color='var(--content-primary-tertiary)' />
          <Typography variant='body-md-regular' ariaLabel='memberName' ellipsis>
            {member.name}
          </Typography>
        </div>
      ))}
      {!!hiddenMembers.length && (
        <Dropdown
          ariaLabel='hiddenMembers'
          triggerComponent={() => (
            <div className={styles.remainderCount}>+{hiddenMembers.length}</div>
          )}
          propsDropdownList={{
            maxHeight: 224,
          }}
          items={hiddenMembers.map((member) => ({
            id: member.id,
            label: member.name,
            className: styles.dropdownItemWrapper,
            labelContent: (
              <div className={styles.dropdownItem}>
                <Icon icon={'inboxOpen'} color='var(--content-primary-tertiary)' />
                <Typography
                  variant='text-input-field-r'
                  color='primary'
                  ariaLabel='dropdownMemberName'
                  ellipsis
                >
                  {member.name}
                </Typography>
              </div>
            ),
          }))}
          placement='bottom-end'
        />
      )}
    </div>
  )
})
